import { useSyncExternalStore } from "react";
import {
  getServiceAvailability,
  subscribeServiceAvailability,
  type ServiceAvailability,
} from "../api/serviceAvailability";

export function useServiceAvailability(): ServiceAvailability {
  return useSyncExternalStore(subscribeServiceAvailability, getServiceAvailability);
}
